import React from "react";
import { Box, makeStyles } from "@material-ui/core";

import "./stripe-elements.scss";
import StripePaymentForm from "./StripePaymentForm";
import StripeBilling from "./StripeBilling";

const useStyles = makeStyles(theme => ({
  title: {
    fontWeight: 500,
    lineHeight: "1.1875rem",
    marginBottom: theme.spacing(2.5)
  },
  vatTitle: {
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(1)
  },
  tooltipBody: {
    maxWidth: 246
  },
  tooltipText: {
    fontSize: ".8125rem !important",
    lineHeight: "15px"
  },
  textField: {
    marginBottom: theme.spacing(0.5),
    overflow: "hidden",
    "& .MuiFormHelperText-root.Mui-error": {
      width: "100%"
    },
    "& + .payment-simple-field": {
      marginLeft: theme.spacing(3)
    }
  },
  selectWrapper: {
    marginTop: "1px",
    marginBottom: theme.spacing(0.5)
  },
  textFieldRow: {
    "& .MuiTextField-root + .MuiTextField-root": {
      marginLeft: theme.spacing(2)
    }
  },
  cardTypes: {
    marginBottom: theme.spacing(2),

    "& img": {
      margin: theme.spacing(0, 0.25)
    },

    "& img:last-child": {
      marginRight: theme.spacing(0)
    }
  },

  termsText: {
    fontWeight: 300,
    fontSize: "0.75rem",
    lineHeight: "0.875rem"
  },
  checkbox: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(-1),
    "& .MuiTypography-body1": {
      fontSize: "0.9375rem",
      lineHeight: "1.125rem"
    },
    "& .MuiIconButton-colorPrimary.Mui-checked svg": {
      color: theme.palette.primary.main
    },
    "& > span:first-of-type": {
      marginRight: theme.spacing(0.375)
    }
  },
  radioGroup: {
    marginBottom: theme.spacing(2.25),
    "& .MuiTypography-root": {
      fontSize: "0.9375rem"
    },
    "& .MuiFormControlLabel-root": {
      marginTop: theme.spacing(-0.125),
      marginBottom: theme.spacing(-0.125)
    },
    "& svg": {
      color: "inherit"
    }
  },
  countryIndicator: {
    width: theme.spacing(5),
    height: 51,
    border: "1px solid #DDD",
    backgroundColor: "#EEEEEE",
    textAlign: "center",
    borderRadius: "2px",
    marginRight: theme.spacing(2),
    fontSize: "15px",
    flexShrink: 0,
    lineHeight: "50px",
    color: "#B6B6B6",
    marginTop: theme.spacing(0.5),
    "&:hover": {
      cursor: "not-allowed"
    }
  },
  borderLeftRadius: {
    borderTopLeftRadius: theme.spacing(1),
    borderBottomLeftRadius: theme.spacing(1),
    backgroundColor: "#fff"
  },
  borderRightRadius: {
    borderTopRightRadius: theme.spacing(1),
    borderBottomRightRadius: theme.spacing(1),
    backgroundColor: "#fff"
  }
}));

export default function StripeForm({
  handleChange,
  errors,
  inputValues,
  cardData,
  userCurrency,
  checked,
  setChecked,
  paymentMethod,
  setPaymentMethod,
  selectValues,
  handleSelect,
  setErrors,
  initialErrorValues
}) {
  const classes = useStyles();

  const billing = (
    <StripeBilling
      classes={classes}
      errors={errors}
      handleChange={handleChange}
      inputValues={inputValues}
      checked={checked}
      setChecked={setChecked}
      selectValues={selectValues}
      handleSelect={handleSelect}
    />
  );
  const payment = (
    <StripePaymentForm
      cardData={cardData}
      classes={classes}
      paymentMethod={paymentMethod}
      setPaymentMethod={setPaymentMethod}
      errors={errors}
      userCurrency={userCurrency}
      handleChange={handleChange}
      inputValues={inputValues}
      setErrors={setErrors}
      initialErrorValues={initialErrorValues}
    />
  );

  return (
    <Box
      display="flex"
      justifyContent="center"
      maxWidth="866px"
      margin="0 auto"
      width="866px"
      component="form"
      flexDirection="row"
    >
      {billing}
      {payment}
    </Box>
  );
}
